import Vue from 'vue'
import request from '@/helpers/request'
import store from '@/store'
import WindowFactory from '@/factory/window'
import moment from 'moment'
import ServerValidationError from '@/helpers/ServerValidationError'

export default {
  SAVE_WINDOW: ({ commit, state }, index) => {
    if (store.getters['employer_windows/windows'][index]) {
      const window = store.getters['employer_windows/windows'][index]
      if (window.status === WindowFactory.CREATE) {
        request(
          'POST',
          `${Vue.config.server}/${Vue.config.modules.crm.api.employers.windows.replace(
            '$employer_id',
            store.getters.employer.id,
          )}`,
          {
            begin_at: moment(window.begin_at).format(Vue.config.format.serverDate),
            end_at: _.isNull(window.end_at) ? null : moment(window.end_at).format(Vue.config.format.serverDate),
            schedule: window.schedule,
          },
          true,
        ).then(
          response => {
            if (response.data.result === 'success') {
              const data = response.data.data

              store.commit('employer_windows/updateWindowFieldByIndex', {
                index: index,
                key: 'id',
                value: data.id,
                withUpdate: false,
              })

              store.dispatch('employer_windows/SAVE_WINDOW', index + 1)
            }
          },
          response => {},
        )
      } else if (window.status === WindowFactory.UPDATE) {
        request(
          'PUT',
          `${Vue.config.server}/${Vue.config.modules.crm.api.employers.window
            .replace('$employer_id', store.getters.employer.id)
            .replace('$window_id', window.id)}`,
          {
            begin_at: moment(window.begin_at).format(Vue.config.format.serverDate),
            end_at: _.isNull(window.end_at) ? null : moment(window.end_at).format(Vue.config.format.serverDate),
            schedule: window.schedule,
          },
          true,
        ).then(
          response => {
            store.commit('employer_windows/updateWindowFieldByIndex', {
              index: index,
              key: 'status',
              value: null,
              withUpdate: false,
            })
            store.dispatch('employer_windows/SAVE_WINDOW', index + 1)
          },
          response => {},
        )
      } else if (window.status === WindowFactory.DELETE) {
        request(
          'DELETE',
          `${Vue.config.server}/${Vue.config.modules.crm.api.employers.window
            .replace('$employer_id', store.getters.employer.id)
            .replace('$window_id', window.id)}`,
          {},
          true,
        ).then(
          response => {
            store.commit('employer_windows/updateWindowFieldByIndex', {
              index: index,
              key: 'status',
              value: null,
              withUpdate: false,
            })
            store.dispatch('employer_windows/SAVE_WINDOW', index + 1)
          },
          response => {},
        )
      } else {
        store.dispatch('employer_windows/SAVE_WINDOW', index + 1)
      }
    } else {
      store.dispatch('employer_windows/GET_WINDOWS')
    }
  },
  SHOW_WINDOW_ERROR: ({ commit, state }, window) => {
    const beginAt = moment(window.begin_at).format(Vue.config.format.date)
    commit('setLoad', false)

    Vue.notify({
      group: 'hasBottomNavigation',
      title: '',
      type: 'error',
      text: Vue.config.localization.ru.windowWithoutInterval.replace('$begin_at', beginAt),
    })
  },
  GET_WINDOWS: ({ commit, state }) => {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.windows.replace(
        '$employer_id',
        store.getters.employer.id,
      )}`,
      {},
      true,
    ).then(
      response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          store.commit('employer_windows/setWindows', data.items)
        }
      },
      e => {
        ServerValidationError.notify(e, 'customerValidation')
      },
    )
  },
}
